import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {ExecutiveComponent} from 'app/layout/components-common/executive/executive.component';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [ExecutiveComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    MatMenuModule,
    CommonModule,
  ],
  exports: [ExecutiveComponent],
})
export class ExecutiveModule {}
